/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartLayout_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartContainer_user$ref: FragmentReference;
export type CartContainer_user = {|
  +serviceId: ?string,
  +$fragmentRefs: CartLayout_user$ref,
  +$refType: CartContainer_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartLayout_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'caaa445902d4ffa3886dae0168ab6dcb';
module.exports = node;
